/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tags_Open_Manager_Aria_LabelInputs */



/**
* | output |
* | --- |
* | "Open tags manager" |
*
* @param {Tags_Open_Manager_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const tags_open_manager_aria_label = /** @type {((inputs?: Tags_Open_Manager_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tags_Open_Manager_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ouvrir le gestionnaire de balises")
	if (locale === "de") return /** @type {LocalizedString} */ ("Tag-Manager öffnen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Apri il gestore dei tag")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Открыть менеджер тегов")
	if (locale === "es") return /** @type {LocalizedString} */ ("Abrir el administrador de etiquetas")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("开放标签管理器")
	if (locale === "ja") return /** @type {LocalizedString} */ ("タグマネージャーを開く")
	if (locale === "hi") return /** @type {LocalizedString} */ ("टैग प्रबंधक खोलें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Abra o gerenciador de tags")
	return /** @type {LocalizedString} */ ("Open tags manager")
});